<template lang="pug">
  b-modal#issueFreeSpin(
  ref="issueFreeSpin"
  :title="$t('ui.combine.issue_free_spin')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.provider')").mb-0
        b-form-select(
          ref="provider"
          :dirty="$v.provider.$dirty"
          :error="$v.provider.$error"
          v-model.trim.lazy="$v.provider.$model"
          :disabled="loading"
          size="sm"
          @change="getFreeRoundGameList($event)"
        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(value="EPIC2") EPIC2
          //- option(value="MEGAH5") MEGAH5
        ValidateResult(:value="$v.provider" :name="$t('ui.provider')")
      b-form-group(:label="$t('ui.game')").mb-0
        b-form-select(
          ref="game_code"
          size="sm"
          :dirty="$v.game_code.$dirty"
          :error="$v.game_code.$error"
          v-model.trim.lazy="$v.game_code.$model"
          :disabled="loading"
          @change="getGameInfo($event)"
        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(v-for="opt in gameCodeOpt" :value="opt.GameCode") {{ opt.GameName }} ({{opt.GameCode}})
        ValidateResult(:value="$v.game_code" :name="$t('ui.game')")
      b-form-group(:label="$t('ui.bet_value')").mb-0
        b-form-select(
          ref="bet_value"
          size="sm"
          :dirty="$v.bet_value.$dirty"
          :error="$v.bet_value.$error"
          v-model.trim.lazy="$v.bet_value.$model"
          :disabled="loading",
        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(v-for="opt in betValueOpt" :value="opt") {{ opt }}
        ValidateResult(:value="$v.bet_value" :name="$t('ui.bet_value')")
      b-form-group(:label="$t('ui.line_bet')").mb-0
        b-form-select(
          ref="line_bet"
          size="sm"
          :dirty="$v.line_bet.$dirty"
          :error="$v.line_bet.$error"
          v-model.trim.lazy="$v.line_bet.$model"
          :disabled="loading"

        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(v-for="opt in lineBetOpt" :value="opt") {{ opt }}
        ValidateResult(:value="$v.line_bet" :name="$t('ui.line_bet')")
      b-form-group(:label="$t('ui.total_round')").mb-0
        DebounceInput(
          size="sm"
          ref="total_round"
          required
          type="text"
          :dirty="$v.total_round.$dirty"
          :error="$v.total_round.$error"
          v-model.trim.lazy="$v.total_round.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.total_round" :name="$t('ui.total_round')")
      b-form-group(:label="$t('ui.max_win_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="max_win_amount"
          required
          type="text"
          :dirty="$v.max_win_amount.$dirty"
          :error="$v.max_win_amount.$error"
          v-model.trim.lazy="$v.max_win_amount.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.max_win_amount" :name="$t('ui.max_win_amount')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import FreeSpinGame from "@/library/FreeSpinGame";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    FreeSpinGame
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: "",
      provider: "",
      game_code: "",
      bet_value: "",
      line_bet: "",
      total_round: "",
      max_win_amount: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gameList: [],
      betValueOpt: [],
      gameCodeOpt: [],
      lineBetOpt: [],
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    account_id: {
      required,
      // alphaNum,
      // minLength: minLength(6),
      maxLength: maxLength(20)
    },
    provider: {
      required
    },
    game_code: {
      required
    },
    bet_value: {
      required
    },
    line_bet: {
      required
    },
    total_round: {
      required,
      integer
    },
    max_win_amount: {
      required,
      decimal
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getGameInfo: function(code) {
      if (code && code != '') {
        this.betValueOpt = this.gameList.filter(item => { return item.GameCode == code })[0]['AvailableBetValue'];
        this.lineBetOpt = this.gameList.filter(item => { return item.GameCode == code })[0]['AvailableLineBet'][0]['LineBets'];
      }
    },
    getFreeRoundGameList: function() {
      if (this.provider == "")
        return;

      let url = "";

      if (this.provider == 'EPIC2')
        url = config.epic2GetFreeRoundGameListUrl();
      else if (this.provider == 'MEGAH5')
        url = config.megah5GetFreeRoundGameListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.gameList = response.data.dt;
                this.gameCodeOpt = this.gameList != null ? this.gameList : [];
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = "";

        if (this.provider == 'EPIC2')
          url = config.epic2CreateFreeRoundUrl();
        else if (this.provider == 'MEGAH5')
          url = config.megah5CreateFreeRoundUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          member_id: this.item.account_id,
          game_code: this.game_code,
          bet_value: this.bet_value,
          line_bet: this.line_bet,
          total_round: this.total_round,
          max_win_amount: this.max_win_amount
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.issueFreeSpin.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "issue_free_spin", this.feedback.status);
                  this.$refs.issueFreeSpin.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.provider= "";
      this.game_code = "";
      this.bet_value = "";
      this.line_bet = "";
      this.total_round = "";
      this.max_win_amount = "";
      this.$refs.provider.$el.focus();
    }
  }
};
</script>
